import { createContext, useCallback, useContext } from 'react'

import { StoreData } from '@/types'

export interface StoresContextValue {
  stores: StoreData[]
  getStoreById: (storeId: string) => StoreData | undefined
}

export const StoresContext = createContext<StoresContextValue | undefined>(
  undefined
)

interface StoresProviderProps {
  children?: React.ReactNode
  stores: StoreData[]
}

export const StoresProvider = ({ children, stores }: StoresProviderProps) => {
  const getStoreById = useCallback(
    (storeId: string) => {
      return stores.find((store) => store.store_id === storeId)
    },
    [stores]
  )
  return (
    <StoresContext.Provider value={{ stores, getStoreById }}>
      {children}
    </StoresContext.Provider>
  )
}

export const useStoresContext = () => {
  const context = useContext(StoresContext)
  if (context === undefined) {
    throw new Error('useUnits was used outside of its Provider')
  }
  return context
}
